import type { Question } from '@api/instant_survey/types';
import { Checkbox, Layout, Select, SparkleSolidIcon, TextArea } from '@utilities';
import type { SelectOption, SelectProps } from '@utilities/components/Select';

import styles from './_index.module.scss';

interface AIPropertiesProps {
  onUpdateQuestionProperties: (change: Partial<Question['properties']>) => void;
  question: Question;
}

const RESPONSE_MODALITY_OPTIONS: SelectOption[] = [
  { label: 'Audio', value: 'audio' },
  { label: 'Video', value: 'video' },
];

const AIProperties = ({ onUpdateQuestionProperties, question }: AIPropertiesProps) => {
  const { properties } = question;
  const isProbingEnabled = Boolean(properties.probingEnabled);
  const selectedModality = RESPONSE_MODALITY_OPTIONS.find(
    ({ value }) => value === (properties.modality ?? 'video')
  );

  const handleModalityChange = (option: null | SelectOption) => {
    if (option?.value === 'audio' || option?.value === 'video') {
      onUpdateQuestionProperties({ modality: option.value });
    }
  };

  return (
    <Layout.Flex.Column className={styles['ai-properties']} gap="x-small">
      <div className={styles['ai-properties-field']}>
        <Checkbox
          isChecked={isProbingEnabled}
          label="Enable follow-up probing"
          onChange={() => onUpdateQuestionProperties({ probingEnabled: !isProbingEnabled })}
          value={isProbingEnabled}
        />
      </div>
      {isProbingEnabled && (
        <>
          <Layout.Flex gap="x-small">
            <SparkleSolidIcon className={styles['ai-properties-sparkle-icon']} />
            <p>Probing Instructions</p>
          </Layout.Flex>
          <p
            className={styles['ai-properties-probing-instructions']}
            id="ai-properties-probing-instructions"
          >
            Provide guidance for the AI moderator to asks follow-up questions, which can be based on
            the panelist&apos;s answers.
          </p>
          {/* <div><Checkbox label="Use research objective" /><div> */}
          <TextArea
            aria-labelledby="ai-properties-probing-instructions"
            autoGrow
            className={styles['ai-properties-probe-guidance']}
            onChange={(probeGuidance) => onUpdateQuestionProperties({ probeGuidance })}
            placeholder="Enter some guidelines..."
            required
            value={properties.probeGuidance ?? ''}
          />
        </>
      )}
      <Select
        className={styles['ai-properties-response-mode']}
        label="Answers Format"
        onChange={handleModalityChange as SelectProps['onChange']}
        options={RESPONSE_MODALITY_OPTIONS}
        value={selectedModality}
      />
    </Layout.Flex.Column>
  );
};

export default AIProperties;
